import { createFileRoute } from "@tanstack/react-router";
import Map from "@/components/map";

export const Route = createFileRoute("/map/")({
  component: MapPage,
});

function MapPage() {
  return (
    <div className={"relative h-full w-full shadow-md"}>
      <Map
        deployments={[]}
        currentPageProp={1}
        pageSizeProp={500}
        mapLocation={null}
        pinnedEventDetail={null}
        timelineItemsById={{}}
        onEventSelect={() => {}}
        onEventHover={() => {}}
        onEventDeselect={() => {}}
      />
    </div>
  );
}
